var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "slider-arrows" }, [
    _c(
      "button",
      {
        staticClass: "slider-arrows__item",
        attrs: { title: "Влево", type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("left")
          },
        },
      },
      [_c("IconComponent", { attrs: { name: "arrow-left-s-line" } })],
      1
    ),
    _c(
      "button",
      {
        staticClass: "slider-arrows__item",
        attrs: { title: "Вправо", type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("right")
          },
        },
      },
      [_c("IconComponent", { attrs: { name: "arrow-right-s-line" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }